import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { datadogRum } from '@datadog/browser-rum';

import { configureStore } from '@eb/redux-configure-store';
import { middleware as analyticsMiddleware } from '@eb/site-analytics';

import { BasePage } from '../base';
import { OverlayProvider } from '../../context/Overlay';

import {
    ConsumerHeader,
    getSearchPageHeaderOffset,
} from '../../components/ConsumerHeader';
import { withStickyBehaviorSearch, withCookieHeaderHeight } from '../../hoc';
import { ConfirmationOverlay } from '../../components/ConfirmationOverlay';

import reducer from '../../redux/reducers';
import { getInitialData } from '../../redux/reducers/utils';
import { isProd } from '../../utils/http';

import { SearchBaseContainer } from './containers';
import '../app.scss';

const EnhancedSearchConsumerHeader = withStickyBehaviorSearch(ConsumerHeader);

export class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });

        this.state = {
            headerOffset: getSearchPageHeaderOffset(props.cookieHeaderHeight),
        };
    }

    componentDidMount() {
        const { cookieHeaderHeight, env } = this.props;

        if (isProd({ env })) {
            datadogRum.addRumGlobalContext('view.sub_app', 'search');
        }

        this.setState({
            headerOffset: getSearchPageHeaderOffset(cookieHeaderHeight),
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.cookieHeaderHeight !== prevProps.cookieHeaderHeight) {
            this.setState({
                headerOffset: getSearchPageHeaderOffset(
                    this.props.cookieHeaderHeight,
                ),
            });
        }
    }

    render() {
        return (
            <Provider store={this._store}>
                <OverlayProvider>
                    <BasePage
                        {...this.props}
                        isSearchPage={true}
                        structureHeader={EnhancedSearchConsumerHeader}
                    >
                        <ConfirmationOverlay />
                        <div
                            className="feed-search-page"
                            style={{ paddingTop: this.state.headerOffset }}
                        >
                            <SearchBaseContainer {...this.props} />
                        </div>
                    </BasePage>
                </OverlayProvider>
            </Provider>
        );
    }
}

export default withCookieHeaderHeight(SearchPage);
